/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import * as global from "../../../js/global";
	import * as helper from "../../../js/helper";
	import full_loading from "../../components/full-loading.vue";
	import property_component from "../../components/property-component.vue";
	import search_filters_modal from "../../modal/search-filters-modal.vue";
	import filter_tablets_component from "../../components/filter-tablets-component.vue";
	const __vue_script__ ={
        components: {
            full_loading:full_loading,
            property_component:property_component,
            search_filters_modal:search_filters_modal,
            filter_tablets_component:filter_tablets_component,
        },
		name:'shared_with_me_properties_widget',
        props: { 
            show_shared: {
                type: Boolean,
                default:false
            },
        },
		data() {
			return {
                global,
                helper,
                frappe,
                is_loading:false,
                search_filters:localStorage.shared_with_me_search_filters?JSON.parse(localStorage.shared_with_me_search_filters):global.search_filters,
                is_ready:false,
				properties: [],
			}
		},
        mounted(){
            global.emitter.on("load-search-again", args => {
                this.load_data(true);
            });
            this.load_data(true);
        },
		methods: {
            load_data: async function(reload=false){
                if(this.is_loading)
                    return;
                this.is_loading = true;
                if(reload){
                    this.page = 0;
                    this.end_of_page = false;
                    while(this.properties.length > 0) {
                        this.properties.pop();
                    }
                }
                let params = {
                    "filters":JSON.stringify(this.search_filters),
                    "page":this.page
                };
                let url = "/api/method/maalek.api.shared_with_me_properties";
                let res = await $.ajax({
                    url: url,
                    type: "GET",
                    data: params
                });
                if(res.message.length > 0){
                    for (let index = 0; index < res.message.length; index++) {
                        this.properties.push(res.message[index]);
                    }
                    this.page++;
                }else{
                    this.end_of_page = 1;
                }
                this.is_loading = false;
                this.is_ready = true;
            }
		},
		computed:{
		}
	}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "my-listing" },
    [
      _c("full_loading"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-2 mt-2" },
        [
          _c("filter_tablets_component", {
            attrs: { search_filters_prop: _vm.search_filters }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "btn-toolbar",
              attrs: {
                role: "toolbar",
                "aria-label": "Toolbar with button groups"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { role: "group", "aria-label": "Third group" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: {
                        type: "button",
                        "data-bs-toggle": "modal",
                        "data-bs-target": "#searchFiltersModal"
                      }
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-sliders" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.helper.t("Filters")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row" },
        [
          _vm._l(_vm.properties, function(property) {
            return _c(
              "div",
              { staticClass: "col-xl-3 col-lg-4" },
              [_c("property_component", { attrs: { property: property } })],
              1
            )
          }),
          _vm._v(" "),
          !_vm.is_loading && _vm.is_ready && _vm.properties.length == 0
            ? _c("h5", { staticClass: "text-center" }, [
                _vm._v(_vm._s(_vm.helper.t("No property shared with you!")))
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c("search_filters_modal", {
        attrs: {
          search_filters_prop: _vm.search_filters,
          for_map_search: false,
          for_guest: true
        }
      })
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-07b49570_0", { source: "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n", map: {"version":3,"sources":[],"names":[],"mappings":"","file":"shared-with-me-properties-widget.vue"}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/widgets/account/shared-with-me-properties-widget.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__